export default __webpack_public_path__ + "static/media/NoPictures.7ade4fe6.svg";